// removed by extract-text-webpack-plugin
module.exports = {"wasabi-linkbutton":"wasabi-linkbutton","icon-rightTop":"icon-rightTop","icon-rightBottom":"icon-rightBottom","onlyicon":"onlyicon","onlytext":"onlytext","wasabi-linkbutton-text":"wasabi-linkbutton-text","left":"left","right":"right"};


//////////////////
// WEBPACK FOOTER
// ./~/wasabiD/Sass/Buttons/linkbutton.scss
// module id = 165
// module chunks = 0